<div class="tabview-innerFilter" *permission="Permission['Gestion.Comercial.Reportes.SeleccionTienda']">
  <div class="form__group">
    <div class="p-float-label">
      <p-dropdown [options]="listStore" [(ngModel)]="selectedStore" (onChange)="onChangeStore(selectedStore)" [editable]="false" optionLabel="name" optionValue="id"></p-dropdown>
      <label>Tienda</label>
    </div>
  </div>
</div>

<p-table [value]="listCommissionsOfUser" styleClass="p-datatable" id="table_commissions_tab">
  <ng-template pTemplate="body" let-commissions>
    <tr>
      <td>
        <div class="datatable__info">
          <i class="pi pi-mobile"></i>
          <div class="datatable__infoText">
            <p>{{commissions.brand.name | titlecase}}</p>
            <span>{{commissions.date | date: 'short' | titlecase}}</span>
          </div>
        </div>
      </td>
      <td>
        <div class="datatable__value">
          <p>{{commissions.amount | currency}}</p>
          <p-tag severity="info" [value]="commissions.status"></p-tag>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
